import { Box, Divider, Stack, TextField, Typography } from "@mui/material";
import TopHeadingDividerComponent from "../AccountSetting/TopHeadingDividerComponent";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import { useState } from "react";
import CalenderIcon from "../../UI/CalenderIcon";
import SaveChangingsButton from "../AccountSetting/SaveChangingsButton";
import api from "../../config/axios";  // Use configured axios instance
import { useNavigate } from "react-router-dom";
import axios from "axios";

function CommunityEventFormSection() {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    startDate: dayjs(),
    startTime: dayjs(),
    endDate: dayjs().add(1, 'hour'),
    endTime: dayjs().add(1, 'hour'),
    location: "",
    privacy: "public"
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDateChange = (newValue, field) => {
    setFormData(prev => ({
      ...prev,
      [field]: newValue
    }));
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      alert("Please enter an event name");
      return false;
    }

    if (!formData.description.trim()) {
      alert("Please enter an event description");
      return false;
    }

    if (!formData.location.trim()) {
      alert("Please enter an event location");
      return false;
    }

    if (!formData.startDate || !formData.startTime) {
      alert("Please select start date and time");
      return false;
    }

    // Validate that end date/time is after start date/time if provided
    if (formData.endDate && formData.endTime) {
      const startDateTime = formData.startDate.hour(formData.startTime.hour()).minute(formData.startTime.minute());
      const endDateTime = formData.endDate.hour(formData.endTime.hour()).minute(formData.endTime.minute());
      
      if (endDateTime.isBefore(startDateTime)) {
        alert("End time must be after start time");
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    console.log("Create event button clicked");
    try {
      // Validate required fields
      if (!formData.name.trim()) {
        alert("Please enter an event name");
        return;
      }

      if (!formData.description.trim()) {
        alert("Please enter an event description");
        return;
      }

      if (!formData.location.trim()) {
        alert("Please enter an event location");
        return;
      }

      const token = localStorage.getItem("token");
      console.log("Token:", token);
      
      if (!token) {
        alert("You must be logged in to create an event");
        return;
      }

      const eventData = {
        name: formData.name.trim(),
        description: formData.description.trim(),
        startDate: formData.startDate.format("YYYY-MM-DD"),
        startTime: formData.startTime.format("HH:mm"),
        endDate: formData.endDate.format("YYYY-MM-DD"),
        endTime: formData.endTime.format("HH:mm"),
        location: formData.location.trim(),
        privacy: formData.privacy
      };

      console.log("Sending data to server:", eventData);

      const response = await api.post("/events", eventData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      console.log("Server response:", response.data);

      if (response.data) {
        alert("Event created successfully!");
        navigate("/community");
      }
    } catch (error) {
      console.error("Error creating event:", error);
      if (!error.response) {
        alert("Network error: Cannot connect to the server. Please check if the backend server is running at http://localhost:8000");
      } else {
        alert("Error creating event: " + (error.response?.data?.message || error.message));
      }
    }
  };

  return (
    <Stack
      sx={{
        bgcolor: "#ffffff",
        borderRadius: "22px",
        p: "20px",
      }}
    >
      <TopHeadingDividerComponent
        primary="Create new event"
        secondary="Based on your profile, preferences, and activity like applies, searches, and saves"
        divider={false}
        primaryBottomPadding="4px"
        secondaryBottomPadding="0px"
      />
      <Divider
        sx={{
          height: "1px",
          bgcolor: "#EBEBEB",
          border: "none",
          my: "18px",
          mx: "-20px",
        }}
      />
      <Box
        component="img"
        src="/images/eventFormPic.png"
        sx={{ borderRadius: "30px" }}
      ></Box>
      <Stack direction="row" gap="20px" sx={{ mt: "20px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            flex: "1",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: "400",
              fontSize: "18px",
              lineHeight: "100%",
              color: "#000000",
            }}
          >
            Event name
          </Typography>
          <TextField
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            variant="outlined"
            fullWidth
            sx={{
              input: {
                bgcolor: "#ffffff",
                color: "#AFAFAF",
                fontSize: "18px",
                boxSizing: "content-box",
                px: "4px",
                py: "12px",
                "&::placeholder": {
                  color: "#AFAFAF",
                },
              },
              "& .MuiOutlinedInput-root": {
                px: "8px",
                borderRadius: "10px",
                bgcolor: "#ffffff",
                "& fieldset": {
                  border: "1px solid #e3e3e3",
                },
                "&:hover fieldset": {
                  border: "1px solid #e3e3e3",
                },
                "&.Mui-focused fieldset": {
                  border: "1px solid #e3e3e3",
                },
              },
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            flex: "1",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: "400",
              fontSize: "18px",
              lineHeight: "100%",
              color: "#000000",
            }}
          >
            Start date
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={formData.startDate}
              onChange={(newValue) => handleDateChange(newValue, 'startDate')}
              slots={{ openPickerIcon: CalenderIcon }}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  borderRadius: "10px",
                  bgcolor: "#ffffff",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #e3e3e3",
                },
              }}
            />
          </LocalizationProvider>
        </Box>
      </Stack>
      <Stack direction="row" gap="20px" sx={{ mt: "20px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            flex: "1",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: "400",
              fontSize: "18px",
              lineHeight: "100%",
              color: "#000000",
            }}
          >
            Start time
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              value={formData.startTime}
              onChange={(newValue) => handleDateChange(newValue, 'startTime')}
              slots={{ openPickerIcon: CalenderIcon }}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  borderRadius: "10px",
                  bgcolor: "#ffffff",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #e3e3e3",
                },
              }}
            />
          </LocalizationProvider>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            flex: "1",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: "400",
              fontSize: "18px",
              lineHeight: "100%",
              color: "#000000",
            }}
          >
            Location
          </Typography>
          <TextField
            name="location"
            value={formData.location}
            onChange={handleInputChange}
            variant="outlined"
            fullWidth
            sx={{
              input: {
                bgcolor: "#ffffff",
                color: "#AFAFAF",
                fontSize: "18px",
                boxSizing: "content-box",
                px: "4px",
                py: "12px",
                "&::placeholder": {
                  color: "#AFAFAF",
                },
              },
              "& .MuiOutlinedInput-root": {
                px: "8px",
                borderRadius: "10px",
                bgcolor: "#ffffff",
                "& fieldset": {
                  border: "1px solid #e3e3e3",
                },
                "&:hover fieldset": {
                  border: "1px solid #e3e3e3",
                },
                "&.Mui-focused fieldset": {
                  border: "1px solid #e3e3e3",
                },
              },
            }}
          />
        </Box>
      </Stack>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          mt: "20px",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: "400",
            fontSize: "18px",
            lineHeight: "100%",
            color: "#000000",
          }}
        >
          Description
        </Typography>
        <TextField
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          variant="outlined"
          fullWidth
          multiline
          rows={4}
          sx={{
            textarea: {
              bgcolor: "#ffffff",
              color: "#AFAFAF",
              fontSize: "18px",
              boxSizing: "content-box",
              px: "4px",
              py: "12px",
              "&::placeholder": {
                color: "#AFAFAF",
              },
            },
            "& .MuiOutlinedInput-root": {
              px: "8px",
              borderRadius: "10px",
              bgcolor: "#ffffff",
              "& fieldset": {
                border: "1px solid #e3e3e3",
              },
              "&:hover fieldset": {
                border: "1px solid #e3e3e3",
              },
              "&.Mui-focused fieldset": {
                border: "1px solid #e3e3e3",
              },
            },
          }}
        />
      </Box>
      <Box sx={{ mt: "20px" }}>
        <SaveChangingsButton 
          onClick={() => {
            console.log("Button clicked");
            handleSubmit();
          }}
        >
          Create event
        </SaveChangingsButton>
      </Box>
    </Stack>
  );
}

export default CommunityEventFormSection;
